module.exports = __webpack_public_path__ + "img/ch75.dbc58e83.png";